module.exports = __webpack_public_path__ + "static/media/HCMM946.77e3c0cd.jpg";